export interface LearnMoreItem {
	image: string;
	image2?: string;
	title: string;
	description?: string;
}

export const ggItems: LearnMoreItem[] = [
	{
		image: "/spec_gift_galore/pop-up-image-1.png",
		title: "Purchase Web Large Gift Boxes with your fellow Club members!"
	},
	{
		image: "/spec_gift_galore/pop-up-image-2.png",
		title: "As more Club members participate, the meter fills up!"
	},
	{
		image: "/spec_gift_galore/pop-up-image-3.png",
		title:
			"When the meter is filled, the WHOLE CLUB earns a BONUS REWARD in their inbox!"
	}
];

export const ggItemsV2: LearnMoreItem[] = [
	{
		image: "/spec_gift_galore/pop-up-image-1.png",
		image2: "[box_url]",
		title: "Purchase [box_name] with your fellow Club members!"
	},
	{
		image: "/spec_gift_galore/pop-up-image-2.png",
		title: "As more Club members participate, the meter fills up!"
	},
	{
		image: "/spec_gift_galore/pop-up-image-4.png",
		title:
			"Progress through multiple Tiers, each offering a new BONUS REWARD for your Club."
	},
	{
		image: "/spec_gift_galore/pop-up-image-3.png",
		title:
			"When the meter is filled, the WHOLE CLUB earns a BONUS REWARD in their inbox!"
	}
];
